export default "__VITE_ASSET__BHRr7Wj1__"